var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TestLayout',{attrs:{"title":"CreativeSizes"}},[(_vm.creative != null)?_c('CreativeRow',{attrs:{"label":"Size (px):"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('CreativeSize',{attrs:{"creative":_vm.creative}})]},proxy:true}],null,false,296499699)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }